document.addEventListener('DOMContentLoaded', () => {
            const loadMoreBtn = document.getElementById('section-load-more-product'); 
            const loadMoreBtnDone = document.getElementById('section-load-more-product-done'); 
            if (!loadMoreBtn) return;
            const collectionId = document.querySelector('.widget-collection-products').dataset.collectionId;
            const textLoad = document.querySelector('.widget-collection-products').dataset.text;
            const colgird = document.querySelector('.widget-collection-products').dataset.colgird;
            const limit = parseInt(document.querySelector('.widget-collection-products').dataset.limit);
            loadMoreBtn.addEventListener('click', async () => {
              const page = parseInt(loadMoreBtn.dataset.nextPage);
              loadMoreBtn.disabled = true;
              loadMoreBtn.textContent = textLoad+'...';
          
              try {
                const response = await fetch(`/collections/${collectionId}/products.json?page=${page}&limit=${limit}`);
                const data = await response.json();
                const products = data.products;
                if (products.length > 0) {
                  const grid = document.getElementById('widget-product-layout');
                  products.forEach(product => {
                    const productTileTemplateUrl = `/products/${product.handle}?view=content`;
                  	return fetch(productTileTemplateUrl)
                  	.then((res) => res.text())
                  	.then((res) => {
                  		const text = res;
                  		const parser = new DOMParser();
                  		const htmlDocument = parser.parseFromString(text, 'text/html');
                  		const productCard = htmlDocument.documentElement.querySelector('.product-item');
                        grid.insertAdjacentHTML('beforeend', '<div class="'+colgird+'">'+productCard.outerHTML+'</div>');
                        if( $('.currency-Picker').length > 0){
                            Currency.convertAll(window.shop_currency, jQuery('select[name=currencies] option:selected').val(), 'span.money', 'money_format');
                        }     
                        initCountd();   
                        smartaddonSS.click_atribute_image();
                  	})
                  	.catch((err) => console.error(`[Shopify Content] Failed to load content for handle: ${product.handle}`, err));           
                  });

                  loadMoreBtn.dataset.nextPage = page + 1;
                  if (products.length < limit) {
                    loadMoreBtn.remove();
                    loadMoreBtnDone.classList.remove("hidden");
                  }
                    
                } else {
                  loadMoreBtn.remove();
                  loadMoreBtnDone.classList.remove("hidden");
                }
              } catch (error) {
                console.error('Error loading more products:', error);
                loadMoreBtn.textContent = 'Error';
              } finally {
                loadMoreBtn.disabled = false;
                loadMoreBtn.textContent = textLoad;
              }
            });
}); 